import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  dayContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    color: 'gray',
    'box-sizing': 'border-box',
    height: '100%',
    borderLeft: `1px solid ${
      theme.palette.type === 'dark' ? '#555' : '#e7e7e7'
    }`,
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      height: 70,
      fontSize: 14,
      width: 100,
      color: 'gray',
      borderLeft: `1px solid ${
        theme.palette.type === 'dark' ? '#555' : '#e7e7e7'
      }`,
      borderBottom: `1px solid ${
        theme.palette.type === 'dark' ? '#555' : '#e7e7e7'
      }`,
      boxSizing: 'border-box'
    },

    '& input': {
      fontSize: 12,
      width: '98%',
      textAlign: 'center',
      border: 'none',
      outline: 'none',
      backgroundColor: 'transparent',
      color: theme.palette.type === 'dark' ? 'white' : 'black'
    },
    '& span:last-child': {
      padding: '6px'
    }
  },
  priceDayContianer: {
    '& input': {
      fontSize: 10
    }
  },
  weekendDayContainer: {
    backgroundColor:
      theme.palette.type === 'dark' ? `rgba(120, 132, 255,0.25)` : '#fff2f2'
  },
  selectedDayContainer: {
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: 4
  },
  editedDayContainer: {
    backgroundColor: theme.palette.info.light
  }
}))

export default useStyles
